module.exports = __webpack_public_path__ + "img/details-hover.267e5124.svg";